import {
  CREATE_ROUTE_SUCCESS,
  CREATE_ROUTE_FAILED,
  CREATE_ROUTE_PENDING,
  GET_TASKS_INFO,
  GET_TASKS_RESET,
  GET_TASKS_INFO_ERROR,
} from "../constants/routeConstants";
import Axios from "axios";
import { API_ROOT } from "../components/utils/api-config";
import { setAlert } from "./alertAction";
import { history } from "../Root";
let token = "Bearer " + localStorage.getItem("token");
const auth = {
  headers: {
    Authorization: token,
  },
};
export const postRoute = (formData, config) => (dispatch) => {
  dispatch({ type: CREATE_ROUTE_PENDING });
  Axios.post(`${API_ROOT}/routes/`, formData, auth, config)
    .then(({ data }) => {
      dispatch({ type: CREATE_ROUTE_SUCCESS, payload: data });
      dispatch(setAlert("Route created", "success"));
      history.push(`/routes/${data.id}`);
    })
    .catch((error) => dispatch({ type: CREATE_ROUTE_FAILED, payload: error }));
};

export const getTasksInfo = (id) => (dispatch) => {
  Axios.get(`${API_ROOT}/routes/${id}`, auth)
    .then((response) =>
      dispatch({ type: GET_TASKS_INFO, payload: response.data })
    )
    .catch((error) => dispatch({ type: GET_TASKS_INFO_ERROR, payload: error }));
};
export const resetTasksInfo = () => {
  return { type: GET_TASKS_RESET };
};
